import { render, staticRenderFns } from "./MainAppSidebar.vue?vue&type=template&id=434b95aa&scoped=true&"
import script from "./MainAppSidebar.vue?vue&type=script&lang=js&"
export * from "./MainAppSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MainAppSidebar.vue?vue&type=style&index=0&id=434b95aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434b95aa",
  null
  
)

export default component.exports